import { SearchLg } from "@untitledui/icons";
import { Input } from "@/components/base/input/input";
import { useAddressSearch } from "../hooks";
import type { AddressSearchInputProps } from "../types/components.types";
import type { NominatimResult } from "../types/tracking";

export const AddressSearchInput = ({
	onLocationSelect,
}: AddressSearchInputProps) => {
	const { query, results, isLoading, isOpen, handleInputChange, closeResults } =
		useAddressSearch();

	const handleSelectResult = (result: NominatimResult) => {
		onLocationSelect(
			Number.parseFloat(result.lat),
			Number.parseFloat(result.lon)
		);
		closeResults();
	};

	const shouldShowResults = isOpen && results.length > 0;

	return (
		<div className="absolute top-4 left-14 z-1000 w-80">
			<div className="relative">
				<Input
					icon={SearchLg}
					onChange={handleInputChange}
					placeholder="Pesquisar endereço no Brasil..."
					value={query}
				/>

				{shouldShowResults ? (
					<div className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md border border-gray-200 bg-white shadow-lg">
						{results.map((result) => (
							<button
								className="w-full px-3 py-2 text-left text-sm hover:bg-gray-100"
								key={`${result.lat}-${result.lon}`}
								onClick={() => handleSelectResult(result)}
								type="button"
							>
								{result.display_name}
							</button>
						))}
					</div>
				) : null}

				{isLoading ? (
					<div className="-translate-y-1/2 absolute top-1/2 right-3">
						<div className="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600" />
					</div>
				) : null}
			</div>
		</div>
	);
};
